
import mainPage from './mainPage';

export default mainPage;
